import { Link } from 'react-router-dom';
import WorkCard from '@/components/feature/WorkCard';
import type { Work } from '@/mocks/catalog';
import { typeLabel } from '@/mocks/catalog';

interface RelatedWorksProps {
  currentType: Work['type'];
  related: Work[];
  fallback: Work[];
}

export default function RelatedWorks({ currentType, related, fallback }: RelatedWorksProps) {
  const list = related.length >= 3 ? related : [...related, ...fallback.filter((w) => !related.some((r) => r.id === w.id))].slice(0, 5);
  const reason = currentType === 'show' ? '同类综艺' : currentType === 'tv' ? '同类型剧集' : '同类型电影';

  return (
    <section className="mt-8">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-lg font-bold text-foreground-950 md:text-xl">相关推荐</h2>
          <p className="mt-1 text-xs text-foreground-500">根据{reason}、题材标签与地区为你挑选</p>
        </div>
        <Link
          to={`/category/${currentType}`}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-accent-700"
        >
          查看{typeLabel[currentType]}频道 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}